export default {
  title: "Work Orders",
  title_overview: "Work Order Overview",
  title_simple: "Work Order",
  title_work_order_items: "Work Items",
  title_work_order_issues: "Work Issues",
  title_side_panel: "Work Order side-panel",
  title_issue_work_comments: "Issues, Performed Work and Comments",
  title_item_work_comments: "Items, Performed Work and Comments",
  title_configure_issue_work_comments: "Configure Issues, Performed Work and Comments",
  title_configure_item_work_comments: "Configure Items, Performed Work and Comments",
  tab_overview: "Overview",
  tab_parameters_instructions: "Parameters and Instructions",
  tab_attached: "Attached",
  tab_issues: "Issues",
  tab_items: "Items",
  tab_performed_work: "Performed Work",
  tab_comments: "Comments",
  tab_issues_with_count: "Issues ({count})",
  tab_items_with_count: "Items ({count})",
  tab_performed_work_with_count: "Performed Work ({count})",
  tab_comments_with_count: "Comments ({count})",
  label_work_domain: "Work Domain",
  label_designation: "Designation",
  label_work_order_designation: "Work Order Designation",
  label_deadline: "Deadline",
  label_reference: "Reference",
  label_time_requirements: "Time Requirements",
  label_material_requirements: "Material Requirements",
  label_work_instructions: "Work Instructions",
  label_work_information: "Work Information",
  label_work_type: "Work Type",
  label_priority: "Priority",
  label_start_date: "Start Date",
  label_started: "Started",
  label_created_by: "Created By",
  label_entity_type: "Entity Type",
  items: "Items",
  areas: "Areas",
  issues: "Issues",
  corrective_work: "Corrective Work",
  regular_work: "Regular Work",
  restricted: "Results restricted to <b class='text-info'>Work Domain</b> <b>{designation}</b>",
  label_select_priority: "Select a priority",
  label_target_procedure: "Target procedure",
  label_accepted_alternative: "Accepted Alternative Procedure",
  label_assignments: "Assignments",
  label_daily_participants: "Daily participants",
  label_participants_actual_and_assigned: "Participants (Actual {'|'} Assigned)",
  label_average_minutes: "Average Minutes per Work",
  label_hours_to_complete: "Hours to complete",
  label_daily_average: "Daily average work hours",
  create_work_order: "Create Work Order",
  error_unique_reference: "Entered reference is already taken. Please enter a unique value.",
  error_value_integer: "Value must be a positive integer",
  requirements_expectations: "requirements and expectations",
  discard_requirements_dialog_title: "Discarding entries",
  discard_requirements_dialog_content: "Are you sure you want to discard these entries?",
  work_order_create: "Work Order Create",
  work_order_corrective: "Work Order Corrective",
  work_order_regular: "Work Order Regular",
  work_performed_count: "Performed ({count} <span class='text-quote-text'>/</span> {totalCount})",
  work_not_performed_count:
    "Not Performed ({count} <span class='text-quote-text'>/</span> {totalCount})",
  nofity_disable_time: "Start date must be set first",
  notify_disable_draft_has_issue: "Work Domain must match the Work Domain of the issue",
  notify_disable_work_domain_priority: "Work domain must be selected first",
  tooltip_participants: "Expected average daily count of participants",
  tooltip_average_minute: "Expected average time in minutes to complete 1 Performed Work",
  tooltip_hours_complete: "Total amount of hours the entire Work Order is expected to take",
  tooltip_hours_daily: "Expected daily hours contributed by each participant",
}
